<template>
  <LazyModal
    v-if="wishlistStore.showMergeList && !cartStore.showMergeList"
    hide-close
    inner-shadow
    class="modal--small">
    <template #modal-header>
      <h3>
        {{ $t('wishlist/merge-prompt-title') }}
      </h3>
    </template>
    <p>
      {{ $t('wishlist/merge-prompt') }}
    </p>
    <div :class="$style['card-container']">
      <ProductCard v-for="(product, n) in wishlistStore.oldProducts" :key="'featured' + n" :product="product" />
    </div>
    <template #modal-footer>
      <Btn
        data-test-id="deny-merge-button"
        @click="wishlistStore.mergeOldProducts(false)">
        {{ $t('wishlist/forget') }}
      </Btn>
      <Btn
        data-test-id="accept-merge-button"
        @click="wishlistStore.mergeOldProducts(true)">
        {{ $t('wishlist/keep') }}
      </Btn>
    </template>
  </LazyModal>

  <LazyModal
    v-if="cartStore.showMergeList && cartStore.oldProducts.length && !loading"
    hide-close
    inner-shadow
    class="modal--small">
    <template #modal-header>
      <h3>
        {{ $t('wishlist/merge-prompt-title') }}
      </h3>
    </template>
    <p>
      {{ $t('cart/merge-prompt') }}
    </p>
    <div
      :class="[
        $style['card-container'],
        $style['card-container--cart']]
      ">
      <ProductMergeCard
        v-for="product in cartStore.oldProducts"
        :key="product.cId + '-' + product.pId"
        :product="product" />
    </div>
    <template #modal-footer>
      <Btn
        data-test-id="deny-cart-merge-button"
        @click="cartMerge(false)">
        {{ $t('cart/forget') }}
      </Btn>
      <Btn
        data-test-id="accept-cart-merge-button"
        @click="cartMerge(true)">
        {{ $t('cart/keep-selection') }}
      </Btn>
    </template>
  </LazyModal>
</template>

<script setup>
const router = useRouter()
const cartStore = useCartStore()
const wishlistStore = useWishlistStore()
const { $lang } = useNuxtApp()
const loading = ref(true)

const cartMerge = async forgetProducts => {
  await cartStore.mergeOldProducts(forgetProducts)
  router.push({ name: $lang + '-cart' })
}

onMounted(() => {
  loading.value = false
})

</script>

<style lang="scss" module>
.card-container {
  display: grid;
  gap: $spacing * 2;
  grid-template-columns: repeat(3, 1fr);

  @media (max-width: #{$breakpoint-mobile}) {
    grid-template-columns: repeat(2, 1fr);
  }

  &--cart {
    grid-template-columns: repeat(2, 1fr);

    @media (max-width: #{$breakpoint-portrait-tablet}) {
      grid-template-columns: 1fr;
    }
  }

}

.button-container {
  display: flex;
  justify-content: space-between;
  max-width: 250px;
  margin: $spacing * 6 auto $spacing * 2;
}

</style>
